export enum DynamicUrlCategory {
  ANALYTICSDASHBOARDS = 'ANALYTICSDASHBOARDS',
  AVANTDATA = 'AVANTDATA',
  AVANTPRODUCT = 'AVANTPRODUCT',
}
